import { render, staticRenderFns } from "./RegistrationTabs.vue?vue&type=template&id=d9862142&"
import script from "./RegistrationTabs.vue?vue&type=script&lang=js&"
export * from "./RegistrationTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports